import ProductInventoryPriceAPICall from "../service/ProductInventoryPriceAPICall";
import store from "../storeWire";
import System from "src/helper/system";
import Helper from "src/helper/Helper";
import Constants from "src/helper/Constants";
import { setInventory, setPricingList } from "src/store/slice/model/ProductInventoryPrice";
import { __remove, __set } from "src/store/axios_indicator";
import { chunk, isArray } from "underscore";
import ProductRepository from "./ProductRepository";

class ProductInventoryPriceRepository {

    getInventoryParams = (product) => {
        let param = {
            distributor: product?.distributor,
            ItemNumber: product?.ItemNumber,
            factory_qoh: product?.factory_qoh,
            ERPPartNumber: product?.ERPPartNumber,
            VendorPartNumber: product?.VendorPartNumber,
            Stock: product?.Stock,
            exists_in_sap: product?.exists_in_sap,
            isAvnetDistributor: product?.isAvnetDistributor,
            isPartnerDistributor: product?.isPartnerDistributor,
            isNewarkDistributor: product?.isNewarkDistributor,
            default_plant: product?.default_plant
        };
        return param
    }

    setinventoryState = (obj) => {
        let master_data = {};
        if (store) {
            let storeIn = store.getState();
            master_data = storeIn.entities.model_ProductInventoryPrice.inventory_list;
        }
        let data = { ...master_data, ...obj }
        store.dispatch(setInventory(data));
    }

    getInventory = async (params, source) => {
        __set('PRODUCT_INVENTORY_API_CALL');
        const { siteUser, systemModules } = Constants;
        let avnetReq = [];
        let newArcReq = "";
        const resObj = {}

        params.map((v) => {
            resObj[v.ItemNumber] = { inventoryQty: 0, factoryStock: parseInt(v.factory_qoh) };
            if (v.isAvnetDistributor) {
                if (v.exists_in_sap) {
                    avnetReq.push({
                        erpPartNumber: v.ERPPartNumber,
                        plant: v.default_plant ? v.default_plant : "1300",
                        targetQty: "0",
                        requestedDeliveryDate: Helper.getSystemDate()
                    })
                }
            } else if (v.isNewarkDistributor) {
                if (v.VendorPartNumber)
                    newArcReq = newArcReq ? newArcReq + " " + v.VendorPartNumber : v.VendorPartNumber

            } else if (v.isPartnerDistributor) {
                resObj[v.ItemNumber] = { inventoryQty: 0, factoryStock: parseInt(v.factory_qoh) };
            }
        });

        if (avnetReq && avnetReq.length) {
            const data = {
                currency: window.mct,
                onOrderedStock: System.avUserInfoData.currentUser === siteUser.CORE && source === systemModules.CART || source === systemModules.CHECKOUT ? "X" : "",
                source: source,
                salesOrderLineItems: avnetReq
            }

            const res = await new ProductInventoryPriceAPICall().getAvnetInventory(data);

            if (res.isSuccessFull && res.data) {
                res.data.map(v => {
                    const matchedItem = params.find(p => {
                        if (p.ERPPartNumber === v.sapMaterialNumber && p.default_plant === v.plant) return p
                    });
                    resObj[matchedItem?.ItemNumber] = { inventoryQty: v.availableQuantity ? parseInt(v.availableQuantity) : 0, factoryStock: parseInt(matchedItem?.factory_qoh) }
                })
            }
        }

        if (newArcReq) {
            const res = await new ProductInventoryPriceAPICall().getNewarcInventory(newArcReq);
            if (res.isSuccessFull && res.data?.stocks) {
                res.data.stocks.map(v => {
                    /* const items = params.filter(p => p.VendorPartNumber === v.vendorPartNumber);
                    if (items?.length) {
                        items.forEach(ele => {
                            resObj[ele.ItemNumber] = { inventoryQty: v.regionalBreakdown?.level ? parseInt(v.regionalBreakdown.level) : parseInt(v.level), factoryStock: parseInt(ele.factory_qoh) }
                        });
                    } */
                    const items = params.filter(p => p.VendorPartNumber === v.vendorPartNumber);
                    if (items?.length) {
                        // Find the U.S. regional entry, if available
                        const usRegion = v.regionalBreakdown?.find(r => r.warehouse?.toUpperCase() === "US");
                        items.forEach(ele => {
                            resObj[ele.ItemNumber] = {
                                inventoryQty: usRegion ? parseInt(usRegion.level) : parseInt(v.level),
                                factoryStock: parseInt(ele.factory_qoh)
                            };
                        });
                    }
                })
           }
        }

        if (resObj && Object.entries(resObj).length)
            this.setinventoryState(resObj)
        __remove('PRODUCT_INVENTORY_API_CALL');
    }

    getInventoryByDistributor = (product, inventory) => {
        return product?.isAvnetDistributor ? (inventory?.inventoryQty + inventory?.factoryStock) : product?.isPartnerDistributor ? inventory?.factoryStock : inventory?.inventoryQty
    }

    getPricingParams(params) {
        if (params?.AllocationFlag || params?.PIMBlock?.toUpperCase() === 'E' || params?.QtyMin <= 0 || params?.QtyMult <= 0) {
            return false;
        } else {

            let params_single = {
                ItemNumber: params?.ItemNumber,
                erpPartNumber: params?.exists_in_sap ? params?.ERPPartNumber : '',
                mdmMaterialId: !params?.exists_in_sap ? params?.MDMMaterialID : '',
                quantity: [params?.quantity ? params.quantity : params?.QtyMin],
                onDockDate: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                plant: params?.default_plant ? params?.default_plant : '',
                customerPartNumber: params?.CPN ? params?.CPN : '',
                endCustAccNum: params?.CPN ? new ProductRepository().getEndCustomerByCpn(params?.CustomerPartNumbers, params?.CPN) : '',
                uniqueId: params.uniqueId
            }
            return params_single
        }
    };

    getExchangeRate = async (params) => {
        return await new ProductInventoryPriceAPICall().getExchangeRate(params)
    };

    getPricingList = async (params, noStateSet = true, currency = window.mct) => {
        let resObj = {}
        if (params && params.length) {

            params.map((obj, i) => {
                obj.itemId = i + 1;
            });

            let chunkParam = chunk(params, 5);

            await Promise.all(chunkParam.map(async (ele) => {
                let priceRes = await new ProductInventoryPriceAPICall().getPricingList(ele, currency)
                let res = {}
                priceRes.map((v, i) => {
                    const { quantityPricingVO, itemId, ...rest } = v;
                    const pricingData = quantityPricingVO.map((obj) => {
                        const { resale, resaleSource, ...rest } = obj;
                        return {
                            marketPrice: resale,
                            priceSource: resaleSource,
                            ...rest
                        };
                    });

                    // remove which have no market price and set in quantity ascending order also filter by selected currency
                    let pricing = pricingData
                        .filter(item => item.marketPrice !== undefined && item.marketPrice !== null && item.marketPrice !== 0 && item.currency === currency)
                        .sort((a, b) => a.quantity - b.quantity);

                    const item = params.find(f => f.itemId == itemId); // use "==" because input as a int and output as a string 

                    const _id = item.uniqueId;
                    const ItemNumber = item.ItemNumber;

                    if (_id) {
                        res[_id] = {
                            ...rest,
                            pricing,
                            ItemNumber: ItemNumber
                        }
                    }
                    res[ItemNumber] = {
                        ...rest,
                        pricing,
                        ItemNumber: ItemNumber
                    }
                })

                resObj = res;
                if (res && Object.entries(res).length && noStateSet) {
                    this.setPricingState(res)
                }
            }))
        }

        return resObj;
    }

    setPricingState = (obj) => {
        let master_data = {};
        if (store) {
            let storeIn = store.getState();
            master_data = storeIn.entities.model_ProductInventoryPrice.pricing_list;
        }
        let data = { ...master_data, ...obj }
        store.dispatch(setPricingList(data))
    }

    getCurrentPriceByQuantityAndPriceArray = (single_product_pricing_list, QuantityToCart, first_tir_price = false) => {

        let current_value_final = 0;
        if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
            if (single_product_pricing_list.length === 1) {
                if (single_product_pricing_list[0].quantity <= QuantityToCart)
                    current_value_final = single_product_pricing_list[0]
            } else {
                single_product_pricing_list.map((current_value, current_index) => {
                    if (current_value_final === 0) {
                        if (single_product_pricing_list.length === current_index + 1) {
                            if (QuantityToCart >= current_value.quantity) {
                                current_value_final = current_value;
                            }
                        } else {
                            const next_price = single_product_pricing_list[current_index + 1];
                            if ((current_value.quantity === QuantityToCart) ||
                                (current_value.quantity < QuantityToCart && next_price.quantity > QuantityToCart)) {
                                current_value_final = current_value;
                            }
                        }
                    }
                });
            }
            if (current_value_final === 0 && first_tir_price) {
                current_value_final = single_product_pricing_list[0];
            }
        }

        return current_value_final;
    };
}

export default ProductInventoryPriceRepository;